module.exports = __webpack_public_path__ + "img/item2.e98eea10.png";